import React from "react";
import { Modal } from "antd";
import "antd/dist/antd.css";
import "./AuthorizeConfirmModal.scss";
import PropTypes from "prop-types";

export default function AuthorizeConfirmModal({
  setModalvisible,
  handleAuthorizeModalOk,
  handleAuthorizeModalCancel,
}) {
  return (
    <>
      <Modal
        className="modal-cancel"
        title="提示"
        visible={setModalvisible}
        okType="text"
        okText="確定"
        cancelText="離開"
        onOk={handleAuthorizeModalOk}
        onCancel={handleAuthorizeModalCancel}
      >
        <p>您將使用APP會員登入新東陽網頁</p>
      </Modal>
    </>
  );
}

// AuthorizeConfirmModal.propTypes = {
//   setModalvisible: PropTypes.bool.isRequired,
//   // setHandleOk: PropTypes.func.isRequired,
//   setHandleCancel: PropTypes.func.isRequired,
// };
